import React from "react";
import s from "./InfoSystemPositions.less";

const InfoSystemPositions = ({ item }) => {
  const { Positions } = item;

  return Positions?.map((name, i) => (
    <p key={i} className={s.title}>
      {name}
    </p>
  ));
};

export default InfoSystemPositions;
